import React from 'react';
import * as styles from '../styles/SweetAlertStyles';
export default (function () {
  return React.createElement("div", {
    style: Object.assign({}, styles.icon, styles.iconWarning)
  }, React.createElement("span", {
    style: styles.iconWarningBody
  }), React.createElement("span", {
    style: styles.iconWarningDot
  }));
});